import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home.vue'
import Cutting from '@/components/Cutting.vue'
import MerchantAdd from '@/components/Merchant/MerchantAdd.vue'
import MerchantAddOtherV2 from '@/components/Merchant/add/index.vue'
import MerchantAddEasypayV2 from '@/components/Merchant/merchantAdd/add.vue'
import signUp from '@/components/Merchant/merchantAdd/signUp.vue' //电子签约
import WxAuthentication from '@/components/Merchant/merchantAdd/WxAuthentication.vue' // 微信认证
import zfbAuthentication from '@/components/Merchant/merchantAdd/zfbAuthentication.vue' // 微信认证

import zhongfuAdd from '@/components/Merchant/merchantAdd/zhongfu.vue'
import MerchantAddV2 from '@/components/Merchant/merchantAdd/index.vue'
import Helipay from '@/components/Merchant/helipay.vue'
import Leshuazf from '@/components/Merchant/leshuazf.vue'
import Umpayer from '@/components/Merchant/umpayer.vue'
import Union from '@/components/Merchant/union.vue'
import Test from '@/components/Merchant/Test.vue'
import store from './store'
// 业务员
import SalesmanLogin from '@/components/Agent/SalesmanLogin.vue'
import SalesmanHome from '@/components/Agent/SalesmanHome.vue'
import SalesmanSetting from '@/components/Agent/SalesmanSetting.vue'
import SalesmanInformation from '@/components/Agent/SalesmanInformation/SalesmanInformation.vue'
import MerchantList from '@/components/Agent/SalesmanInformation/MerchantList.vue'
import MerchantEdit from '@/components/Agent/SalesmanInformation/MerchantEdit.vue'
import MerchantInfo from '@/components/Agent/SalesmanInformation/MerchantInfo.vue'
import SalesmanBaseInfo from '@/components/Agent/SalesmanInformation/SalesmanBaseInfo.vue'
import SalesmanChangePwd from '@/components/Agent/SalesmanInformation/SalesmanChangePwd.vue'

import MerchantEditZhongfu from '@/components/Agent/SalesmanInformation/MerchantEditZhongfu.vue'

import Gangway from '@/components/Merchant/Gangway.vue';

import StoreImpower from '@/components/MerchantCenter/StoreImpower.vue'; //门店登录
import MerchantImpower from '@/components/MerchantCenter/MerchantImpower.vue'; //商户登录
import AgentImpower from '@/components/MerchantCenter/AgentImpower.vue'; //代理登录


import MerchantLogin from '@/components/MerchantCenter/MerchantLogin.vue'; //商户登录
import StoreLogin from '@/components/MerchantCenter/StoreLogin.vue'; //门店登录
import AgentLogin from '@/components/MerchantCenter/AgentLogin.vue'; //门店登录

import AgentHomepage from '@/components/MerchantCenter/AgentHomepage.vue'; //代理首页
import MerchantHomepage from '@/components/MerchantCenter/MerchantHomepage.vue'; //商户首页
import StoreHomepage from '@/components/MerchantCenter/StoreHomepage.vue'; //门店首页
import QuickPayment from '@/components/MerchantCenter/QuickPayment.vue'; //微信扫码收款
import Summary from '@/components/MerchantCenter/Summary.vue'; //商户交易汇总
import StoreSummary from '@/components/MerchantCenter/StoreSummary.vue'; //门店交易汇总
import AgentSummary from '@/components/MerchantCenter/AgentSummary.vue'; //业务员交易汇总
import MerchantStoreSummary from '@/components/MerchantCenter/MerchantStoreSummary.vue'; //代理交易汇总


import MerchantInformation from '@/components/MerchantCenter/MerchantInformation/MerchantInformation.vue'; //商户信息
import StoresInformation from '@/components/MerchantCenter/StoresInformation/StoresInformation.vue'; //门店信息
import BasicInformation from '@/components/MerchantCenter/MerchantInformation/BasicInformation.vue'; //基本信息
import StoresBasicInformation from '@/components/MerchantCenter/StoresInformation/StoresBasicInformation.vue'; //门店基本信息
import StoreInformation from '@/components/MerchantCenter/MerchantInformation/StoreInformation.vue'; //门店信息
import StoresStoreInformation from '@/components/MerchantCenter/StoresInformation/StoresStoreInformation.vue'; //门店基本信息
import StoresStoreInformationUpdate from '@/components/MerchantCenter/StoresInformation/StoresStoreInformationUpdate.vue'; //门店基本信息修改
import StaffManagement from '@/components/MerchantCenter/MerchantInformation/StaffManagement.vue'; //员工管理
import ChangePassword from '@/components/MerchantCenter/MerchantInformation/ChangePassword.vue'; //修改密码
import StoresChangePassword from '@/components/MerchantCenter/StoresInformation/StoresChangePassword.vue'; //门店密码
import ServiceInformation from '@/components/MerchantCenter/MerchantInformation/ServiceInformation.vue'; //客服信息


import TransactionFlow from '@/components/MerchantCenter/TransactionFlow/TransactionFlow.vue'; //交易流水
import StoresTransactionFlow from '@/components/MerchantCenter/StoreTransactionFlow/StoresTransactionFlow.vue'; //门店交易流水
import TransactionDetails from '@/components/MerchantCenter/TransactionFlow/TransactionDetails.vue'; //订单明细
import StoresTransactionDetails from '@/components/MerchantCenter/StoreTransactionFlow/StoresTransactionDetails.vue'; //门店订单明细
import TransactionSearch from '@/components/MerchantCenter/TransactionFlow/TransactionSearch.vue'; //订单查询
import StoresTransactionSearch from '@/components/MerchantCenter/StoreTransactionFlow/StoresTransactionSearch.vue';


//代理端 SalesmanUpdate
import SalesmanManagement from '@/components/MerchantCenter/SalesmanManagement/SalesmanManagement.vue'; //代理端业务员管理
import SalesmanLoginAgent from '@/components/MerchantCenter/SalesmanManagement/SalesmanLogin.vue'; //代理端业务员管理
import SalesmanUpdate from '@/components/MerchantCenter/SalesmanManagement/SalesmanUpdate.vue'; //代理端业务员管理

import AgentManagement from '@/components/MerchantCenter/SalesmanManagement/AgentManagement.vue'; //代理端下级代理管理
import AgentLoginAgent from '@/components/MerchantCenter/SalesmanManagement/AgentLoginAgent.vue'; //代理端下级代理管理
import AgentUpdate from '@/components/MerchantCenter/SalesmanManagement/AgentUpdate.vue'; //代理端下级代理修改



import MerchantManagement from '@/components/MerchantCenter/MerchantManagement/MerchantManagement.vue'; //代理端商户管理
import MerchantInfoymm from '@/components/MerchantCenter/MerchantManagement/MerchantInfoymm.vue'; //代理端商户管理


import AgentMerchantFlow from '@/components/MerchantCenter/TransactionFlow/AgentMerchantFlow.vue'; //交易流水
import AgentTransactionDetails from '@/components/MerchantCenter/TransactionFlow/AgentTransactionDetails.vue'; //交易流水详情

import AgentMerchantCollect from '@/components/MerchantCenter/TransactionFlow/AgentMerchantCollect.vue'; //交易流水
import MyAccount from '@/components/MerchantCenter/TransactionFlow/MyAccount.vue'; //我的账户
import ApplyWithdrawal from '@/components/MerchantCenter/TransactionFlow/ApplyWithdrawal.vue'; //提现
import ApplyWithDetails from '@/components/MerchantCenter/TransactionFlow/ApplyWithDetails.vue'; //提现详情
import AgentAnalysis from '@/components/MerchantCenter/AgentAnalysis.vue'; //数据分析

//代理基本信息
import AgentInfomation from '@/components/MerchantCenter/AgentInfomation/AgentInfomation.vue'; //代理信息
import AgentBasicinfomation from '@/components/MerchantCenter/AgentInfomation/AgentBasicinfomation.vue'; //代理基本信息
import AgentChangePassword from '@/components/MerchantCenter/AgentInfomation/AgentChangePassword.vue'; //代理修改密码


import SeatList from '@/components/MerchantCenter/CodeOrder/SeatList.vue'; //桌位列表
import SeatAdd from '@/components/MerchantCenter/CodeOrder/SeatAdd.vue'; //桌位列表
import SeatUpdate from '@/components/MerchantCenter/CodeOrder/SeatUpdate.vue'; //桌位列表

Vue.use(Router)
const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'Home',
            component: Home
        },
        {
            path: '/Cutting',
            name: 'Cutting', //裁剪图片
            component: Cutting,
            meta: {
                title: '裁剪图片'
            }
        },
        {
            path: '/MerchantAdd',
            name: 'MerchantAdd', //商户进件
            component: MerchantAdd,
            meta: {
                title: '商户进件'
            }
        },
        {
            path: '/Gangway',
            name: 'Gangway', //通道设置
            component: Gangway,
            meta: {
                title: '通道设置'
            }
        },
        {
            path: '/Helipay',
            name: 'Helipay', //合利宝
            component: Helipay,
            meta: {
                title: '合利宝'
            }
        },
        {
            path: '/Umpayer',
            name: 'Umpayer', //联动
            component: Umpayer,
            meta: {
                title: '联动'
            }
        },
        {
            path: '/Leshuazf',
            name: 'Leshuazf', //乐刷支付
            component: Leshuazf,
            meta: {
                title: '乐刷支付'
            }
        },
        {
            path: '/Union',
            name: 'Union', //银联
            component: Union,
            meta: {
                title: '银联'
            }
        },

        {
            path: '/SalesmanLogin',
            name: 'SalesmanLogin', //业务员登录
            component: SalesmanLogin,
            meta: {
                title: '业务员登录'
            }
        },
        {
            path: '/SalesmanHome',
            name: 'SalesmanHome', //业务员主页
            component: SalesmanHome,
            meta: {
                title: '业务员主页'
            },
        },
        {
            path: '/SalesmanInformation',
            name: 'SalesmanInformation', //业务员信息
            component: SalesmanInformation,
            meta: {
                title: '业务员信息'
            }
        },
        {
            path: '/MerchantList',
            name: 'MerchantList', //商户列表
            component: MerchantList,
            meta: {
                title: '商户列表'
            }
        },
        //MerchantEdit
        {
            path: '/MerchantEdit',
            name: 'MerchantEdit', //商户列表
            component: MerchantEdit,
            meta: {
                title: '商户信息'
            }
        },
        // MerchantEditZhongfu
        {
            path: '/MerchantEditZhongfu',
            name: 'MerchantEditZhongfu', //商户列表
            component: MerchantEditZhongfu,
            meta: {
                title: '商户信息'
            }
        },
        {
            path: '/MerchantInfo/:id',
            name: 'MerchantInfo', //商户信息
            component: MerchantInfo,
            meta: {
                keepAlive: true,
                title: '商户信息'
            }
        },
        {
            path: '/SalesmanSetting',
            name: 'SalesmanSetting', //个人设置
            component: SalesmanSetting,
            meta: {
                title: '个人设置'
            }
        },
        {
            path: '/SalesmanBaseInfo',
            name: 'SalesmanBaseInfo', //业务员个人信息
            component: SalesmanBaseInfo,
            meta: {
                title: '业务员个人信息'
            }
        },
        {
            path: '/SalesmanChangePwd',
            name: 'SalesmanChangePwd', //修改密码
            component: SalesmanChangePwd,
            meta: {
                title: '修改密码'
            }
        },
        {
            path: '/Test',
            name: 'Test',
            component: Test,
            meta: {
                title: ''
            }
        },
        {
            path: '/Merchant/add',
            name: 'MerchantAdd', //商户添加V2
            component: MerchantAddV2,
            meta: {
                title: '商户添加V2'
            }
        },
        {
            path: '/Merchant/addOther',
            name: 'MerchantAddOther', //商户添加V2
            component: MerchantAddOtherV2,
            meta: {
                title: '商户添加V2'
            }
        }, {
            path: '/Merchant/addEasypay',
            name: 'MerchantAddEasypay', //商户添加V2
            component: MerchantAddEasypayV2,
            meta: {
                title: '易生商户添加'
            }
        },
        {
            path: '/Merchant/zhongfu',
            name: 'MerchantZhongfu', //商户添加V2
            component: zhongfuAdd,
            meta: {
                title: '中付商户添加'
            }
        },
        // 电子签约
        {
            path: '/signUp',
            name: 'signUp', //电子签约
            component: signUp,
            meta: {
                title: '电子签约'
            }
        },
        // 认证
        {
            path: '/WxAuthentication',
            name: 'WxAuthentication', //电子签约
            component: WxAuthentication,
            meta: {
                title: '微信认证'
            }
        },
        {
            path: '/zfbAuthentication',
            name: 'zfbAuthentication', //电子签约
            component: zfbAuthentication,
            meta: {
                title: '支付宝认证'
            }
        },

        {
            path: '/AgentImpower',
            name: 'AgentImpower',
            component: AgentImpower,
            meta: {
                title: '代理登录'
            }
        },
        {
            path: '/MerchantImpower',
            name: 'MerchantImpower', //商户登录
            component: MerchantImpower,
            meta: {
                title: '商户登录'
            }
        },
        {
            path: '/StoreImpower',
            name: 'StoreImpower', //门店登录
            component: StoreImpower,
            meta: {
                title: '门店登录'
            }
        },
        {
            path: '/MerchantLogin',
            name: 'MerchantLogin', //商户登录
            component: MerchantLogin
        },
        {
            path: '/StoreLogin',
            name: 'StoreLogin', //门店登录
            component: StoreLogin,
            meta: {
                title: '门店登录'
            }
        },
        {
            path: '/AgentLogin',
            name: 'AgentLogin', // 代理登录
            component: AgentLogin,
            meta: {
                title: '代理登录'
            }
        },
        {
            path: '/AgentHomepage',
            name: 'AgentHomepage',
            component: AgentHomepage,
            meta: {
                title: ''
            }
        },
        {
            path: '/MerchantHomepage',
            name: 'MerchantHomepage', //商户首页
            component: MerchantHomepage,
            meta: {
                title: '商户首页'
            }
        },
        {
            path: '/StoreHomepage',
            name: 'StoreHomepage', //门店首页
            component: StoreHomepage,
            meta: {
                title: '门店首页'
            }
        },
        {
            path: '/QuickPayment',
            name: 'QuickPayment', //商户首页
            component: QuickPayment,
            meta: {
                title: '商户首页'
            }
        },
        {
            path: '/Summary',
            name: 'Summary', //交易汇总
            component: Summary,
            meta: {
                title: '交易汇总'
            }
        },
        {
            path: '/StoreSummary',
            name: 'StoreSummary', //门店交易汇总
            component: StoreSummary,
            meta: {
                title: '门店交易汇总'
            }
        },
        {
            path: '/AgentSummary',
            name: 'AgentSummary', // 业务员交易汇总
            component: AgentSummary,
            meta: {
                title: '业务员交易汇总'
            }
        },
        {
            path: '/MerchantInformation',
            name: 'MerchantInformation', //商户信息
            component: MerchantInformation,
            meta: {
                title: '商户信息'
            }
        },
        {
            path: '/StoresInformation',
            name: 'StoresInformation', //门店信息
            component: StoresInformation
        },
        {
            path: '/StoresStoreInformation',
            name: 'StoresStoreInformation', //门店信息
            component: StoresStoreInformation,
            meta: {
                title: '门店信息',
                keepAlive: true
            }
        },
        {
            path: '/StoresStoreInformationUpdate',
            name: 'StoresStoreInformationUpdate', //门店信息修改
            component: StoresStoreInformationUpdate,
            meta: {
                title: '修改门店信息',
            }
        },
        {
            path: '/BasicInformation',
            name: 'BasicInformation', //基本信息
            component: BasicInformation,
            meta: {
                title: ''
            }
        },
        {
            path: '/StoresBasicInformation',
            name: 'StoresBasicInformation', //门店基本信息
            component: StoresBasicInformation,
            meta: {
                title: ''
            }
        },
        {
            path: '/StoreInformation',
            name: 'StoreInformation', //门店信息
            component: StoreInformation,
            meta: {
                title: ''
            }
        },
        {
            path: '/StaffManagement',
            name: 'StaffManagement', //员工管理
            component: StaffManagement,
            meta: {
                title: ''
            }
        },
        {
            path: '/ChangePassword',
            name: 'ChangePassword', //修改密码
            component: ChangePassword,
            meta: {
                title: ''
            }
        },
        {
            path: '/StoresChangePassword',
            name: 'StoresChangePassword', //修改密码
            component: StoresChangePassword,
            meta: {
                title: ''
            }
        },
        {
            path: '/ServiceInformation',
            name: 'ServiceInformation', //客服信息
            component: ServiceInformation,
            meta: {
                title: ''
            }
        },
        {
            path: '/TransactionFlow',
            name: 'TransactionFlow', //交易流水
            component: TransactionFlow,
            meta: {
                title: ''
            }
        },
        {
            path: '/StoresTransactionFlow',
            name: 'StoresTransactionFlow', //门店交易流水
            component: StoresTransactionFlow,
            meta: {
                title: ''
            }
        },
        {
            path: '/TransactionDetails',
            name: 'TransactionDetails', //订单明细
            component: TransactionDetails,
            meta: {
                title: ''
            }
        },
        {
            path: '/StoresTransactionDetails',
            name: 'StoresTransactionDetails', //订单明细
            component: StoresTransactionDetails,
            meta: {
                title: ''
            }
        },
        {
            path: '/TransactionSearch',
            name: 'TransactionSearch', //订单查询
            component: TransactionSearch,
            meta: {
                title: ''
            }
        },
        {
            path: '/StoresTransactionSearch',
            name: 'StoresTransactionSearch', //订单查询
            component: StoresTransactionSearch,
            meta: {
                title: ''
            }
        },
        {
            path: '/SalesmanManagement',
            name: 'SalesmanManagement', //代理端业务员管理
            component: SalesmanManagement,
            meta: {
                title: ''
            }
        },
        {
            path: '/SalesmanLoginAgent',
            name: 'SalesmanLoginAgent', //代理端添加业务员
            component: SalesmanLoginAgent,
            meta: {
                title: ''
            }
        },
        {
            path: '/SalesmanUpdate',
            name: 'SalesmanUpdate', // 代理端修改业务员信息
            component: SalesmanUpdate,
            meta: {
                title: ''
            }
        },
        {
            path: '/MerchantManagement',
            name: 'MerchantManagement', // 代理端商户管理
            component: MerchantManagement,
            meta: {
                title: ''
            }
        },
        {
            path: '/MerchantInfoymm',
            name: 'MerchantInfoymm', //代理商户管理详细信息
            component: MerchantInfoymm,
            meta: {
                title: ''
            }
        },
        /*  ----------------------新增路由----业务端 -------------------------- */


        {
            path: '/merchants_add',
            name: 'merchants_add', // 卡券开通
            component: () =>
                import('@/components/Agent/SalesmanInformation/merchants_add/index.vue'),
            meta: {
                title: '卡券开通',
                keepAlive: true
            }
        },

        // {
        //     path: '/merchants_add_changeMap',
        //     name: 'merchants_add_changeMap', // 商户入驻选择地址
        //     component: () =>
        //         import ('@/components/Agent/SalesmanInformation/merchants_add/map.vue'),
        //     meta: {
        //         title: '选择地址',
        //         keepAlive: true
        //     }
        // },
        // 商户活动详情
        {
            path: '/cardDetail',
            name: "cardDetail",
            component: () =>
                import('@/components/Agent/SalesmanInformation/merchant_components/cardDetail.vue'),
            meta: {
                title: '卡券详情'
            }
        },
        // 商户核销详情
        {
            path: '/verificationDetail',
            name: 'verificationDetail',
            component: () =>
                import('@/components/Agent/SalesmanInformation/merchant_components/verificationDetail'),
            meta: {
                title: '核销详情'
            }
        },
        // 企业入驻
        {
            path: '/enterprise_add',
            name: 'enterprise_add',
            component: () =>
                import('@/components/Agent/SalesmanInformation/enterprise_add/index'),
            meta: {
                title: '企业入驻'
            }
        },
        // 企业查询
        {
            path: '/enterprise_list',
            name: 'enterprise_list',
            component: () =>
                import('@/components/Agent/SalesmanInformation/enterprise_list/index'),
            meta: {
                title: '企业列表'
            }
        },
        // 企业详情
        {
            path: '/enterprise_detail',
            name: 'enterprise_detail',
            component: () =>
                import('@/components/Agent/SalesmanInformation/enterprise_list/enterprise_detail'),
            meta: {
                title: '企业详情'
            }
        },
        // 员工列表

        {
            path: '/companyConsumer',
            name: 'companyConsumer',
            component: () =>
                import('@/components/Agent/SalesmanInformation/enterprise_list/companyConsumer'),
            meta: {
                title: '员工列表'
            }
        },
        {
            path: '/consumerDetail',
            name: 'consumerDetail',
            component: () =>
                import('@/components/Agent/SalesmanInformation/enterprise_list/consumer_detail'),
            meta: {
                title: '员工详情'
            }
        },
        // 选择位置
        {
            path: '/changeMap',
            name: 'changeMap',
            component: () =>
                import('@/components/map.vue'),
            meta: {
                title: '选择地址'
                // keepAlive: true
            }

        },
        //
        /*-----------------新增业务端路由结束---------------------------------------- */

        /**
         * 新增商户端路由
         */
        // {
        //     path: '/statement',
        //     name: 'statement', //报表查询
        //     component: () =>
        //         import ('@/components/MerchantCenter/statement/index'),
        //     meta: {
        //         title: '卡券列表'
        //     }
        // },
        {
            path: '/statement_list',
            name: 'statement_list', //卡券列表
            component: () =>
                import('@/components/MerchantCenter/statement/statement_list'),
            meta: {
                title: '卡券列表'
            }
        },
        {
            path: '/statement_detail',
            name: 'statement_detail', //卡券详情
            component: () =>
                import('@/components/MerchantCenter/statement/statement_detail'),
            meta: {
                title: '卡券详情'
            }
        },
        {
            path: '/statement_get',
            name: 'statement_get', //领取列表
            component: () =>
                import('@/components/MerchantCenter/statement/statement_get'),
            meta: {
                title: '领取列表'
            }
        },
        {
            path: '/statement_get_detail',
            name: 'statement_get_detail', //领取详情
            component: () =>
                import('@/components/MerchantCenter/statement/statement_get_detail'),
            meta: {
                title: '领取详情'
            }
        },
        {
            path: '/statement_use',
            name: 'statement_use', //使用列表
            component: () =>
                import('@/components/MerchantCenter/statement/statement_use'),
            meta: {
                title: '使用列表'
            }
        },
        {
            path: '/statement_use_detail',
            name: 'statement_use_detail', //使用详情
            component: () =>
                import('@/components/MerchantCenter/statement/statement_use_detail'),
            meta: {
                title: '使用详情'
            }
        },
        //商户端会员
        {
            path: '/member_card',
            name: 'member_card', //会员卡
            component: () =>
                import('@/components/MerchantCenter/MemberCard/index'),
            meta: {
                title: '会员卡管理'
            }
        },
        {
            path: '/member_card_add',
            name: 'member_card_add', //添加会员卡
            component: () =>
                import('@/components/MerchantCenter/MemberCard/MemberCardAdd'),
            meta: {
                title: '添加会员卡'
            }
        },
        {
            path: '/member_card_update',
            name: 'member_card_update', //修改会员卡
            component: () =>
                import('@/components/MerchantCenter/MemberCard/MemberCardUpdate'),
            meta: {
                title: '修改会员卡'
            }
        },
        {
            path: '/member',
            name: 'member', //会员管理
            component: () =>
                import('@/components/MerchantCenter/Member/index'),
            meta: {
                title: '会员管理'
            }
        },
        {
            path: '/member_list',
            name: 'member_list', //会员列表
            component: () =>
                import('@/components/MerchantCenter/Member/member_list'),
            meta: {
                title: '会员列表'
            }
        },
        {
            path: '/balance',
            name: 'balance', //余额明细
            component: () =>
                import('@/components/MerchantCenter/Member/balance'),
            meta: {
                title: '余额明细'
            }
        },
        {
            path: '/integral',
            name: 'integral', //积分明细
            component: () =>
                import('@/components/MerchantCenter/Member/integral'),
            meta: {
                title: '积分明细'
            }
        },
        //扫码点餐
        {
            path: '/CodeOrder',
            name: 'CodeOrder',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/index'),
            meta: {
                title: '扫码点餐'
            }
        },
        {
            path: '/FoodClassList',
            name: 'FoodClassList',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodClassList'),
            meta: {
                title: '菜品分类'
            }
        },
        {
            path: '/FoodClassAdd',
            name: 'FoodClassAdd',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodClassAdd'),
            meta: {
                title: '添加菜品分类'
            }
        },
        {
            path: '/FoodClassUpdate',
            name: 'FoodClassUpdate',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodClassUpdate'),
            meta: {
                title: '修改菜品分类'
            }
        },
        {
            path: '/FoodList',
            name: 'FoodList',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodList'),
            meta: {
                title: '菜品列表'
            }
        },
        {
            path: '/FoodAdd',
            name: 'FoodAdd',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodAdd'),
            meta: {
                title: '添加菜品'
            }
        },
        {
            path: '/FoodUpdate',
            name: 'FoodUpdate',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodUpdate'),
            meta: {
                title: '修改菜品'
            }
        },
        {
            path: '/editFoodStatus',
            name: 'editFoodStatus',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/editFoodStatus'),
            meta: {
                title: '批量上下架菜品'
            }
        },
        {
            path: '/FoodManagement',
            name: 'FoodManagement',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodManagement'),
            meta: {
                title: '菜品管理'
            }
        },
        {
            path: '/ClassSort',
            name: 'ClassSort',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/ClassSort'),
            meta: {
                title: '菜品分类排序'
            }
        },
        {
            path: '/ManagementIndustry',
            name: 'ManagementIndustry',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/ManagementIndustry'),
        },
        {
            path: '/SellType',
            name: 'SellType',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/SellType'),
        },
        {
            path: '/FoodsLibrary',
            name: 'FoodsLibrary',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodsLibrary'),
            meta: {
                title: '菜品库'
            }
        },
        {
            path: '/FoodsStatistic',
            name: 'FoodsStatistic',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/FoodsStatistic'),
            meta: {
                title: '菜品统计'
            }
        },
        {
            path: '/recharge',
            name: 'recharge',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/recharge'),
            meta: {
                title: '充值'
            }
        }, {
            path: '/rechargereRecord',
            name: 'rechargereRecord',
            component: () =>
                import('@/components/MerchantCenter/CodeOrder/rechargereRecord'),
            meta: {
                title: '充值记录'
            }
        },
        {
            path: '/Order',
            name: 'Order',
            component: () =>
                import('@/components/MerchantCenter/Order/index'),
            meta: {
                title: '订单列表'
            }
        },
        {
            path: '/OrderDetails',
            name: 'OrderDetails',
            component: () =>
                import('@/components/MerchantCenter/Order/OrderDetails'),
            meta: {
                title: '订单详情'
            }
        },
        {
            path: '/orderRefund',
            name: 'orderRefund',
            component: () =>
                import('@/components/MerchantCenter/Order/orderRefund'),
            meta: {
                title: '订单退款'
            }
        },
        {
            path: '/ConsumerOrderStatistics',
            name: 'ConsumerOrderStatistics',
            component: () =>
                import('@/components/MerchantCenter/ConsumerOrderStatistics/index'),
            meta: {
                title: '销售记录'
            }
        },
        {
            path: '/storeConsumer',
            name: 'storeConsumer',
            component: () =>
                import('@/components/MerchantCenter/ConsumerOrderStatistics/storeConsumer'),
            meta: {
                title: '门店销售记录'
            }
        },
        //业务员开通扫码点餐
        {
            path: '/OpenOrderCode',
            name: 'OpenOrderCode',
            component: () =>
                import('@/components/Agent/SalesmanInformation/OpenOrderCode.vue'),
            meta: {
                title: '开通扫码点餐'
            }
        },
        {
            path: '/StoreInfo',
            name: 'StoreInfo',
            component: () =>
                import('@/components/Agent/SalesmanInformation/StoreInfo.vue'),
            meta: {
                title: '门店信息'
            }
        },
        {
            path: '/StoreInfoUpdate',
            name: 'StoreInfoUpdate',
            component: () =>
                import('@/components/Agent/SalesmanInformation/StoreInfoUpdate.vue'),
            meta: {
                title: '修改门店信息'
            }
        },


        /**
         * 新增商户端路由结束
         */
        {
            path: '/AgentMerchantFlow',
            name: 'AgentMerchantFlow', //  代理端商户管理
            component: AgentMerchantFlow
        },
        {
            path: '/MerchantStoreSummary',
            name: 'MerchantStoreSummary', // 代理端商户汇总
            component: MerchantStoreSummary
        },
        {
            path: '/AgentMerchantCollect',
            name: 'AgentMerchantCollect', // 代理端交易汇总
            component: AgentMerchantCollect
        },
        {
            path: '/AgentManagement',
            name: 'AgentManagement', //代理端下级代理管理
            component: AgentManagement
        },
        {
            path: '/AgentLoginAgent',
            name: 'AgentLoginAgent', //代理端下级代理管理添加代理
            component: AgentLoginAgent
        },
        {
            path: '/AgentUpdate',
            name: 'AgentUpdate', //代理端下级代理修改代理
            component: AgentUpdate
        },
        {
            path: '/MyAccount',
            name: 'MyAccount', //代理端我的账户
            component: MyAccount
        },
        {
            path: '/ApplyWithdrawal',
            name: 'ApplyWithdrawal', //申请提现
            component: ApplyWithdrawal
        },
        {
            path: '/AgentTransactionDetails',
            name: 'AgentTransactionDetails', //交易流水详情
            component: AgentTransactionDetails
        },
        {
            path: '/AgentAnalysis',
            name: 'AgentAnalysis', //数据分析
            component: AgentAnalysis
        },
        {
            path: '/AgentInfomation',
            name: 'AgentInfomation', //代理信息
            component: AgentInfomation
        },
        {
            path: '/AgentBasicinfomation',
            name: 'AgentBasicinfomation', //代理基本信息
            component: AgentBasicinfomation
        },
        {
            path: '/AgentChangePassword',
            name: 'AgentChangePassword', //代理修改密码
            component: AgentChangePassword
        },
        {
            path: '/ApplyWithDetails',
            name: 'ApplyWithDetails', //提现详情
            component: ApplyWithDetails
        },
        {
            path: '/SeatList',
            name: 'SeatList', // 桌位列表
            component: SeatList
        },
        {
            path: '/SeatAdd',
            name: 'SeatAdd', //桌位
            component: SeatAdd
        },
        {
            path: '/SeatUpdate',
            name: 'SeatUpdate', //桌位
            component: SeatUpdate
        }
    ]
})
// 获取真实有效微信签名URL
function getWechatSignUrl(to) {

    if (isIos()) {
        return window.location.href;
    } else {
        // 此处$appHost需要自行处理
        return store.state.baseUrl + to.fullPath
    }
}
//全局判断是否IOS方法
function isIos() {
    const u = navigator.userAgent;
    return u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
}
router.beforeEach((to, from, next) => {
    store.commit("wxSignUrl", getWechatSignUrl(to));

    next()
})



export default router